<template>
  <div class="helpCenter">
    <v-topBar :yellowPageColumn='yellowPageColumn' :productAndSolutionColumn='productAndSolutionColumn' :hitSearchUrl='hitSearchUrl' :enterpriseResourceBaseUrl="enterpriseResourceBaseUrl"> </v-topBar>
    <div class="setNavBg">
      <v-header :navigationColumnInfos='navigationColumnInfos' :webConfigInfo='webConfigInfo'  :hitSearchUrl='hitSearchUrl' :enterpriseResourceBaseUrl="enterpriseResourceBaseUrl"></v-header>
    </div>
    <v-publicBanner :bannerInfo="bannerInfo"></v-publicBanner>
    <div class="helpDetailsCon clearfix">
      <div class="helpDetailsLeft pull-left">
        <!-- <v-collapseNav :collapseMenu="collapseMenu" @fatherData="helpConFn"></v-collapseNav> -->
        <el-menu :default-active="defaultActive" class="el-menu-vertical-demo" @open="handleOpen" @close="handleClose" @select="handleselect"
          theme="dark" unique-opened >
            <el-submenu :index="item.columnId" v-for="(item,index) in helpCenterColumnInfos" :key="index">
              <template slot="title">{{item.columnName}}</template>
              
              
              <el-submenu v-for="(child,childIndex) in item.children" v-show="child.children" :key="childIndex" :index="child.columnId" popper-class="thirdLevelNav">
                <template slot="title">{{child.columnName}}</template>
                <el-menu-item v-for="(child3,childIndex3) in child.children" :key="childIndex3" :index="child3.columnId" @click="clickMenu(child3)">{{child3.columnName}}</el-menu-item>
              </el-submenu>
              
              
              <el-menu-item v-for="(child,childIndex) in item.children" v-show="!child.children" :key="childIndex" :index="child.columnId" @click="clickMenu(child)">{{child.columnName}}</el-menu-item>
              
            </el-submenu>
        </el-menu>


      </div>
      <div class="helpDetailsRight">
        <div class="breadCon">
          <ol class="breadNav">
            <li><a @click.stop="goToHref('/helpCenter')">帮助中心</a></li>
            <li>{{parentColunmnName}}</li>
            <li class="active">{{currentColumnName}}</li>
          </ol>
        </div>
        <div class="helpRightCon">
          <h5 class="title" v-html="currentColumnName"></h5>
          <div class="getCon" v-html="columnContent">
            
          </div>
        </div>
      </div>
    </div>
    <v-footer :webConfigInfo='webConfigInfo'  :footerColumnInfos='footerColumnInfos'></v-footer>
    <v-backToTop></v-backToTop>
  </div>
</template>
<script>
  import header from '@/components/v-header/header'
  import topBar from '@/components/topBar'
  import publicBanner from '@/components/publicBanner'
  import footer from '@/components/v-footer'
  import accordion from '@/components/accordion'
  import backToTop from '@/components/backToTop'
  export default {
    props: [],
    data () {
      return {
        hitSearchUrl:'',
        bannerInfo: {title: '帮助中心',content: "Help center"},
        helpCon: {classA:'新手入门',classB:"复星采招平台"},//帮助中心详情内容
        webConfigInfo: {},
        footerColumnInfos:[],
        helpCenterColumnInfos:[],
        helpCenterInfo:{},
        parentColunmnName:"",
        currentColumnName:"",
        columnContent:"",
        defaultActive:"",
        columnInfo:{},
        navigationColumnInfos:[],
        enterpriseResourceBaseUrl:'',
        yellowPageColumn:{},
        productAndSolutionColumn:{}
      }
    },
    components: {
      'v-header': header,
      'v-topBar': topBar,
      'v-publicBanner': publicBanner,
      'v-footer': footer,
      'v-accordion':accordion,
      'v-backToTop':backToTop
    },
    created () {
      let query = this.$route.query;
      this.columnId = query.columnId;
      this.defaultActive = this.columnId;
      this.$axios.post('/onelink.mdata.main.api/helpCenter/findHelpCentorInfo', {
      columnType: 0,
      columnId:this.columnId
      }).then((res) => {
        this.data = res.data;
        this.helpCenterColumnInfos = this.data.helpCenterColumnInfos;
        this.webConfigInfo = this.data.webConfigInfoDto;
        this.footerColumnInfos = this.data.footerColumnInfos;
        this.navigationColumnInfos = this.data.navigationColumnInfos;
        this.helpCenterInfo = res.data.columnInfo;
        this.parentColunmnName = this.helpCenterInfo.parentColumnName;
        this.currentColumnName = this.helpCenterInfo.columnName;
        this.columnContent = this.helpCenterInfo.columnContent;
        this.hitSearchUrl = this.data.hitSearchUrl;
        this.yellowPageColumn = this.data.yellowPageColumn;
        this.productAndSolutionColumn = this.data.productAndSolutionColumn;
        this.enterpriseResourceBaseUrl = this.data.enterpriseResourceBaseUrl;
      }).catch((err) => {
        console.log(err)
      })
    },
    mounted () {
    },
    methods: {
      helpConFn(val){
        this.helpCon=val
      },
			handleOpen(key, keyPath) {
        // console.log(key, keyPath);
      },
			handleClose() {
				//console.log('handleclose');
			},
			handleselect (index, columnInfo) {
      //  console.log();
        // this.parentColunmnName = columnInfo.parentColumnName;
        // this.currentColumnName = columnInfo.columnName;
        // this.columnContent = columnInfo.columnContent;
			},
      clickMenu(columnInfo){
        // console.log(columnInfo);
        this.parentColunmnName = columnInfo.parentColumnName;
        this.currentColumnName = columnInfo.columnName;
        this.columnContent = columnInfo.columnContent;
      },
      goToHref(val){
        this.$router.push({path: val})
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/helpDetails/index.vue